module.exports = __webpack_public_path__ + "img/img13.80852b0a.svg";